import React from "react";
import { Modal } from "reactstrap";
import CreateInvoiceForm from "./CreateInvoiceForm";

const CreateInvoiceModal = ({ program, isOpen, setOpen, toggle }) => {
  const props = { btnLabel: "Create Invoice", program, setOpen, toggle };

  return (
    <Modal
      className="program-settings modal-2col modal-lg"
      isOpen={isOpen}
      toggle={() => setOpen(true)}
    >
      <div className="left">
        <div className="modal-2col__left-head">
          <span className="modal-2col__eyebrow">Billing</span>
          <h3 className="modal-2col__title">Create Invoice</h3>
          <p className="modal-2col__description">
            Enter the funding amount for the selected program and generate a
            single invoice you can download as a PDF. Once payment is received
            by check or ACH, the program balance will be updated.
          </p>
        </div>
      </div>

      <div className="right">
        <button type="button" className="modal-2col__close" onClick={toggle} aria-label="Close">
          Close
        </button>
        <CreateInvoiceForm {...props} />
      </div>
    </Modal>
  );
};

export default CreateInvoiceModal;
